"use client";

import React from "react";
import "./LoadingAnimation.css";

/*
 * Zentrale Ladeanimation der App: drei pulsierende Chevrons (links -> mitte ->
 * rechts). Reines SVG + CSS, kein Lottie/JS-Asset. Da alle Stellen
 * <LoadingAnimation /> importieren, wirkt eine Aenderung hier ueberall.
 */
function LoadingAnimation({ style }) {
  return (
    <div className="loading-container" style={style}>
      <span className="chevron-loader" role="status" aria-label="Wird geladen">
        <svg
          viewBox="0 0 1536 768"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M309.574 205.681L382.492 205.715C396.16 205.719 412.768 205.312 426.219 206.127C455.759 234.309 486.022 265.899 514.996 294.901C544.191 324.124 575.153 354.181 603.622 383.863C595.2 393.737 579.288 408.836 569.7 418.472L510.649 478.06L457.011 531.836C448.034 540.884 434.987 554.957 425.898 562.687C414.363 563.546 396.428 563.043 384.384 563.029C358.912 562.897 333.439 562.951 307.967 563.192C327.233 545.647 349.292 522.323 368.116 503.526L487.522 383.896L309.574 205.681Z" />
          <path d="M605.292 205.655L682.919 205.645C692.734 205.641 713.678 205.082 722.482 206.288C727.916 211.415 733.225 216.964 738.554 222.232C792.712 275.764 845.417 331.17 899.966 384.279C862.34 422.57 824.502 460.651 786.453 498.521C765.36 519.603 743.543 542.689 722.038 563.071C684.552 563.985 642.603 562.874 604.538 563.148L727.71 439.732C743.045 424.336 769.321 399.445 782.983 383.831C776.534 376.572 766.127 366.878 759.04 359.839L717.844 318.581C680.568 280.699 643.05 243.056 605.292 205.655Z" />
          <path d="M899.011 205.568C936.036 205.909 978.717 204.481 1015.15 205.881C1031.04 219.807 1053.93 244.584 1069.79 260.292L1193.43 384.104C1146.81 432.204 1098.37 478.833 1051.54 526.767C1039.69 538.901 1027.59 551.394 1015.21 562.955C1003.85 563.579 986.645 563.045 974.886 563.038L897.664 563.076C903.768 557.999 913.244 548.035 919.092 542.198L959.057 502.092C997.771 463.341 1038.61 423.327 1076.58 384.069C1069.67 375.978 1058.56 365.496 1050.95 357.919L1013.72 320.541L899.011 205.568Z" />
        </svg>
      </span>
    </div>
  );
}

export default LoadingAnimation;
